import {
  Banknote,
  Building,
  Building2,
  Calculator,
  ClipboardCheck,
  ClipboardList,
  Cog,
  Coins,
  Droplet,
  Eye,
  Factory,
  FileSearch,
  FileSignature,
  FileText,
  FileUp,
  Flame,
  Gauge,
  Gavel,
  GitCompareArrows,
  Hammer,
  Handshake,
  HardHat,
  Home,
  Landmark,
  Layers,
  Newspaper,
  Percent,
  Phone,
  PiggyBank,
  ScanLine,
  ShieldCheck,
  Snowflake,
  Sparkles,
  Sun,
  Thermometer,
  Tractor,
  TrendingDown,
  Upload,
  Users,
  Wallet,
  Wind,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react';

/**
 * Mapping iconName (string en BDD) → composant Lucide.
 * Permet aux contenus seedés de référencer une icône par nom.
 */
const ICONS: Record<string, LucideIcon> = {
  banknote: Banknote,
  building: Building,
  'building-2': Building2,
  calculator: Calculator,
  'clipboard-check': ClipboardCheck,
  'clipboard-list': ClipboardList,
  cog: Cog,
  coins: Coins,
  droplet: Droplet,
  eye: Eye,
  factory: Factory,
  'file-search': FileSearch,
  'file-signature': FileSignature,
  'file-text': FileText,
  'file-up': FileUp,
  flame: Flame,
  gauge: Gauge,
  gavel: Gavel,
  'git-compare-arrows': GitCompareArrows,
  hammer: Hammer,
  handshake: Handshake,
  'hard-hat': HardHat,
  home: Home,
  landmark: Landmark,
  layers: Layers,
  newspaper: Newspaper,
  percent: Percent,
  phone: Phone,
  'piggy-bank': PiggyBank,
  'scan-line': ScanLine,
  'shield-check': ShieldCheck,
  snowflake: Snowflake,
  sparkles: Sparkles,
  sun: Sun,
  thermometer: Thermometer,
  tractor: Tractor,
  'trending-down': TrendingDown,
  upload: Upload,
  users: Users,
  wallet: Wallet,
  wind: Wind,
  wrench: Wrench,
  zap: Zap,
};

/** Récupère un composant icône par nom, fallback Sparkles si inconnu. */
export function getIcon(name: string | null | undefined): LucideIcon {
  if (!name) return Sparkles;
  return ICONS[name] ?? Sparkles;
}
